import { Component, signal } from '@angular/core';

import { Router } from '@angular/router';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AuthService } from '../../../core/services/auth.service';
import { tap } from 'rxjs/operators';
import { AppButtonComponent } from '../../../shared/components/button/app-button.component';

@Component({
  selector: 'app-login-page',
  standalone: true,
  imports: [ReactiveFormsModule, AppButtonComponent],
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})
export class LoginPage {
  loading = signal(false);
  error = signal('');
  showPassword = signal(false);

  form = new FormGroup({
    email: new FormControl('', {
      nonNullable: true,
      validators: [Validators.required, Validators.email],
    }),
    password: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
  });

  constructor(
    private auth: AuthService,
    private router: Router,
  ) {}

  togglePassword() {
    this.showPassword.update((v) => !v);
  }

  submit() {
    if (this.form.invalid) {
      this.error.set('Por favor completa los campos.');
      return;
    }

    this.loading.set(true);
    this.error.set('');

    const { email, password } = this.form.value;

    this.auth.login(email!, password!).subscribe({
      next: (res) => {
        this.auth.setSession(res);

        if (res.user.mustChangePassword) {
          this.router.navigateByUrl('/change-password');
        } else {
          this.router.navigateByUrl('/dashboard');
        }

        this.loading.set(false);
      },
      error: () => {
        this.error.set('Credenciales incorrectas o usuario inactivo');
        this.loading.set(false);
      },
    });
  }
  goToForgot() {
    this.router.navigateByUrl('/forgot-password');
  }

  onForgotPassword() {
    this.error.set('Función no disponible por ahora.');
  }
}
